export enum ImplementationOwners {
  NotSelected = 0,
  Customer = 1,
  Boostability = 2
}